const colors = {
  primaryColor: '#44107A',
  secondaryColor: '#FF1361',
  gradient: 'linear-gradient(-225deg, #231557 0%, #44107A 29%, #FF1361 67%, #FFF800 100%)',
};

export default colors;
